import { DeclarationType } from "../../app/eDeclarations";
import { DeclarationStatus } from "../../shared/statuses";

export type MandateDetails = {
    declarationId: string | null;
    declarationType: DeclarationType;
    declarationStatus: DeclarationStatus | null;
    declarationRequested: string | null;
    declarationSigned: string | null;
    expiryDate: string | null;
    mandateId: string | null;
    cancelledDate: string | null;
    licenceCountryOrigin: string | null;
    firstReminderScheduledDate: string | null;
    firstReminderSentDate: string | null;
    secondReminderScheduledDate: string | null;
    secondReminderSentDate: string | null;
    thirdReminderScheduledDate: string | null;
    thirdReminderSentDate: string | null;
    declarationReminderLastSentDate: string | null;
    hasInFlightDeclaration: boolean;
    inFlightDeclarationId: string | null;
    inFlightDeclarationType: DeclarationType | null;
};

export const getActiveDeclarationType = (
    mandateDetails: MandateDetails
): DeclarationType =>
    mandateDetails.hasInFlightDeclaration
        ? mandateDetails.inFlightDeclarationType ??
          mandateDetails.declarationType
        : mandateDetails.declarationType;
